/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";
import { ReactComponent as DeleteDefaultIcon } from '../../../resources/images/people-dark-large.svg';

/* Styles */
import styles from "./styles";

const DeleteDefaultTeamModal = ({showDeleteDefaultTeamModal, setShowDeleteDefaultTeamModal}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showDeleteDefaultTeamModal }
      setShowModal={ setShowDeleteDefaultTeamModal }
      modalIcon={ <DeleteDefaultIcon /> }
      modalTitle={ <FormattedMessage id="deleteDefaultTeamModal.title"/> }
      modalDescription={<p className={classes.deleteDefaultDescription}><FormattedMessage id="deleteDefaultTeamModal.description"/></p> }
      modalFooter={ <Footer setShowModal={setShowDeleteDefaultTeamModal} /> }
      dataTestId="deletedefaultteammodal"
    />
  )
}

export default DeleteDefaultTeamModal;
